import {httpService} from "@/modules/common/services";

const generatePublicUrl = async (entity_type, entity_uid) => {
    try {
      const params = {new_api: true, entity_type, entity_uid};
        const {data} = await httpService.post('business/links/v1/links/create_payment_link', params);
        return data.public_url
    } catch (error) {
        return {error};
    }
}

export default {generatePublicUrl};
